import { TrackGadget } from "./track-gadget";
import { observable, reaction } from "mobx";

export class WaveformTrackGadget extends TrackGadget {
  @observable notifyTimeSelect = 0;
  lastTimeSelect = -1;
  waveformData = null;
  fillStyle = "#000000";

  onTimeSelect(f) {
    this.disposers.push(reaction(() => this.notifyTimeSelect, f));
  }

  handleMouseClickAtTime(x, y, time) {
    this.lastTimeSelect = time;
    this.notifyTimeSelect++;
    return true;
  }

  setWaveformData(waveformData) {
    this.waveformData = waveformData;
    this.requestFullRedraw();
  }

  drawForegroundLayer(ctx) {}

  drawBackgroundLayer(ctx) {
    if (!this.waveformData) {
      return;
    }
    ctx.save();
    ctx.fillStyle = this.fillStyle;
    const sampleDurationMS = 10;
    const startTime = this.canvasStartTime;
    const startSample = Math.round(startTime / sampleDurationMS);
    const numSamples = Math.round(this.canvasTimeExtent / sampleDurationMS);
    for (let i = 0; i < numSamples; i++) {
      const sampleValue = this.waveformData[startSample + i];
      const sampleTime = startTime + sampleDurationMS * i;
      // TODO unhardcode amplitude scaling
      this.drawTimerangeRect(
        ctx,
        { start: sampleTime, end: sampleTime + sampleDurationMS },
        (this.height * sampleValue) / 80000
      );
    }
    ctx.restore();
  }
}
